export default __webpack_public_path__ + "static/media/media-partners4.0ad7e1dc.webp";